<template>
  <div>
    <ul class="list">
      <li v-for="item in dataList" :key="item.id">
        <image class="pic" lazy-load :src="item.imageUrl" mode="aspectFill"  />
		<div class="box">
			<div class="cover">
			  <div class="txt">
				{{ item.contentTitle }}
			  </div>
			</div>
			<div class="label" v-if="item.money">
			  <span class="symbol">￥</span>
			  <span class="money">{{ item.money }}</span>
			  <span class="symbol">起</span>
			</div>
			<div class="score">
			  AAAA
			</div>
		</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "vanOnePic",
  data() {
    return {
      
    };
  },
  props: {
    dataValue: {
      type: Object,
      default() {
        return {
          name: "发现精彩",
          interfaceUrl: ""
        };
      }
    },
	dataList: {
	      type: Array,
	      default () {
	        return []
	      }
	    }
  }
};
</script>

<style lang="less" scoped>
.list {
  li {
    width: 345px;
    height: 170px;
    margin: 5px 15px;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    color: #fff;
	.box{
		width: 345px;
		height: 170px;
		position: absolute;
		width:345px;height:170px;
		left:0;
		top:0;
	}
    .pic{
      width: 100%;
      height: 100%;
    }
	
    .cover {
      position: absolute;
      left: 0;
      bottom: 0;
      overflow: hidden;
	  width:345px;
	  box-sizing: border-box;
      padding: 12px 12px 6px 12px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.85) 100%
      );
      .txt {
        height: 42px;
        border-radius: 0px 0px 4px 4px;
        font-size: 15px;
        line-height: 21px;
        font-family: PingFangSC-Regular, PingFang SC;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    .label {
      position: absolute;
      right: 0;
      top: 0;
      padding: 7px 8px;
      background: linear-gradient(
        128deg,
        rgba(255, 111, 86, 1) 0%,
        rgba(255, 43, 39, 1) 100%
      );
      border-radius: 50px 4px 0px 50px;
      display: flex;
      .symbol {
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        // font-weight:600;
      }
      .money {
        font-size: 15px;
        font-weight: bold;
        font-family: HelveticaNeue-Bold, HelveticaNeue;
        margin: -2px 3px 0 0;
      }
    }
    .score {
      width: 44px;
      height: 15px;
      line-height: 15px;
      background: rgba(255, 116, 11, 1);
      border-radius: 3px 0px 8px 0px;
      text-align: center;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 11px;
      font-family: PingFangHK-Regular, PingFangHK;
    }
  }
}
</style>
